import { UI } from "../constants/tokens";

// ─── SVG Nav Icons ────────────────────────────────────────────────────────────
export function IconHome({ active }) {
  const c = active ? UI.text.primary : UI.text.muted;
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <path d="M3 10.5L12 3l9 7.5" stroke={c} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M5 9.5V20a1 1 0 001 1h12a1 1 0 001-1V9.5" stroke={c} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M9.5 21v-6h5v6" stroke={c} strokeWidth="1.5" strokeLinejoin="round"/>
    </svg>
  );
}
export function IconPortfolio({ active }) {
  const c = active ? UI.text.primary : UI.text.muted;
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <line x1="4" y1="21" x2="20" y2="21" stroke={c} strokeWidth="1.5" strokeLinecap="round"/>
      <rect x="3.75" y="13" width="4" height="8" rx="0.8" stroke={c} strokeWidth="1.5"/>
      <rect x="10" y="9" width="4" height="12" rx="0.8" stroke={c} strokeWidth="1.5"/>
      <rect x="16.25" y="4" width="4" height="17" rx="0.8" stroke={c} strokeWidth="1.5"/>
      <polyline points="5.75,12.5 12,8.5 18.25,3.5" stroke={c} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}
export function IconSimulator({ active }) {
  const c = active ? UI.text.primary : UI.text.muted;
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="7" stroke={c} strokeWidth="1.5"/>
      <circle cx="12" cy="12" r="2.5" stroke={c} strokeWidth="1.5"/>
      <line x1="12" y1="2" x2="12" y2="5" stroke={c} strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="12" y1="19" x2="12" y2="22" stroke={c} strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="2" y1="12" x2="5" y2="12" stroke={c} strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="19" y1="12" x2="22" y2="12" stroke={c} strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  );
}
export function IconNews({ active }) {
  const c = active ? UI.text.primary : UI.text.muted;
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" stroke={c} strokeWidth="1.5" strokeLinejoin="round"/>
      <polyline points="14,2 14,8 20,8" stroke={c} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <line x1="8" y1="13" x2="16" y2="13" stroke={c} strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="8" y1="17" x2="13" y2="17" stroke={c} strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  );
}
export function IconAlerts({ active, triggered }) {
  // A fired alert is not a loss — the state is carried by the filled dot and
  // by the icon going to full-strength text, not by an alarm colour.
  const c = triggered ? UI.text.primary : active ? UI.text.primary : UI.text.muted;
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9" stroke={c} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M13.73 21a2 2 0 01-3.46 0" stroke={c} strokeWidth="1.5" strokeLinecap="round"/>
      {triggered && <circle cx="18" cy="5" r="3" fill={UI.text.primary}/>}
    </svg>
  );
}
export function IconAI({ active }) {
  const c = active ? UI.text.primary : UI.text.muted;
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="3" fill={active ? UI.text.primary : "none"} stroke={c} strokeWidth="1.5"/>
      <path d="M12 2v3M12 19v3M4.22 4.22l2.12 2.12M17.66 17.66l2.12 2.12M2 12h3M19 12h3M4.22 19.78l2.12-2.12M17.66 6.34l2.12-2.12" stroke={c} strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  );
}
export function IconSettings({ active }) {
  const c = active ? UI.text.primary : UI.text.muted;
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="3" stroke={c} strokeWidth="1.5"/>
      <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 01-2.83 2.83l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z" stroke={c} strokeWidth="1.5"/>
    </svg>
  );
}
export function IconCalendar({ active }) {
  const c = active ? UI.text.primary : UI.text.muted;
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <rect x="3" y="4" width="18" height="17" rx="2" stroke={c} strokeWidth="1.5"/>
      <line x1="3" y1="9" x2="21" y2="9" stroke={c} strokeWidth="1.5"/>
      <line x1="8" y1="2" x2="8" y2="6" stroke={c} strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="16" y1="2" x2="16" y2="6" stroke={c} strokeWidth="1.5" strokeLinecap="round"/>
      <circle cx="8" cy="14" r="1.2" fill={c}/>
      <circle cx="12" cy="14" r="1.2" fill={c}/>
      <circle cx="16" cy="14" r="1.2" fill={c} opacity=".6"/>
      <circle cx="8" cy="18" r="1.2" fill={c} opacity=".6"/>
    </svg>
  );
}
export function IconCalculator({ active }) {
  const c = active ? UI.text.primary : UI.text.muted;
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <rect x="4" y="2" width="16" height="20" rx="2" stroke={c} strokeWidth="1.5"/>
      <rect x="7" y="5" width="10" height="4" rx="1" stroke={c} strokeWidth="1.5"/>
      <circle cx="8" cy="13" r="1.2" fill={c}/>
      <circle cx="12" cy="13" r="1.2" fill={c}/>
      <circle cx="16" cy="13" r="1.2" fill={c}/>
      <circle cx="8" cy="17" r="1.2" fill={c} opacity=".6"/>
      <circle cx="12" cy="17" r="1.2" fill={c} opacity=".6"/>
      <circle cx="16" cy="17" r="1.2" fill={c} opacity=".6"/>
    </svg>
  );
}
export function IconQA({ active }) {
  const c = active ? UI.text.primary : UI.text.muted;
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="10" stroke={c} strokeWidth="1.5"/>
      <path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3" stroke={c} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="12" cy="17" r="0.6" fill={c} stroke={c} strokeWidth="0.5"/>
    </svg>
  );
}
export function IconAcademy({ active }) {
  const c = active ? UI.text.primary : UI.text.muted;
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <path d="M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2z" stroke={c} strokeWidth="1.5" strokeLinejoin="round"/>
      <path d="M22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z" stroke={c} strokeWidth="1.5" strokeLinejoin="round"/>
    </svg>
  );
}

// A globe with a meridian and a parallel — the exposure screen answers "where",
// and this is the same line weight and 22px box as every other nav icon.
export function IconGlobe({ active }) {
  const c = active ? UI.text.primary : UI.text.muted;
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="9" stroke={c} strokeWidth="1.5"/>
      <path d="M3 12h18" stroke={c} strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M12 3c2.5 2.5 3.8 5.6 3.8 9S14.5 18.5 12 21c-2.5-2.5-3.8-5.6-3.8-9S9.5 5.5 12 3z" stroke={c} strokeWidth="1.5" strokeLinejoin="round"/>
    </svg>
  );
}

export function IconProfile({ active }) {
  const c = active ? UI.text.primary : UI.text.muted;
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="8" r="4" stroke={c} strokeWidth="1.5"/>
      <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" stroke={c} strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  );
}

// "מה אם" · a balance: the portfolio before and after, side by side.
export function IconScenario({ active }) {
  const c = active ? UI.text.primary : UI.text.muted;
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <line x1="12" y1="4" x2="12" y2="20" stroke={c} strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="7" y1="20" x2="17" y2="20" stroke={c} strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="5" y1="7" x2="19" y2="7" stroke={c} strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M5 7l-2.5 5.5a2.5 2.5 0 005 0L5 7zM19 7l-2.5 5.5a2.5 2.5 0 005 0L19 7z" stroke={c} strokeWidth="1.5" strokeLinejoin="round"/>
    </svg>
  );
}
